// import external dependencies
import 'jquery';
import 'jquery-match-height';
import 'jquery-validation';
import 'slick-carousel/slick/slick.min';

/** import bootstrap dependencies */
import 'bootstrap/js/src/modal.js';

// Import everything from autoload
import './autoload/_apply-email-handler.js'; import './autoload/_bootstrap.js'

import './gutenberg_components/_awards.js'; import './gutenberg_components/_contact-form.js'; import './gutenberg_components/_fixed-scroller.js'; import './gutenberg_components/_gene-therapy.js'; import './gutenberg_components/_grid.js'; import './gutenberg_components/_homepage-top-hero-carousel.js'; import './gutenberg_components/_image-overlay.js'; import './gutenberg_components/_latest-post-type.js'; import './gutenberg_components/_title-copy-list.js';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';

import Calculator from './modules/calculator';

new Calculator();

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js